//Dependencies
import { all, call, takeEvery, fork, put } from "@redux-saga/core/effects";

//Action Types
import {
    COMMON_DATAVIEW_GET_DATA_REQUEST,
    GENERATE_VALIDATION_CODE
} from 'Redux/actionTypes';

//Actions
import {
    getDataViewResult,
    generateValidationCodeResult
} from 'Redux/actions';

//Helpers
import {
    clientQuery,
    clientMutation
} from 'Core/data/GraphQLApi';
//Endpoints
import {
    endpoints
} from 'Core/defaultValues';
//Errors
import {
    ExceptionManager
} from 'Core/logManager';

function* getDataViewRequest({ payload }) {
    const { entity, query, page, sort, rows, conditions } = payload;
    let newConditions = [];
    conditions.map((condition, index) => {
        if (condition?.fields) {
            let filters = {
                fields: condition?.fields || [],
                terms: condition?.terms || [],
                exact: condition.exact || false,
                conditionOperator: condition.conditionOperator
            }
            if (condition?.range) {
                filters.range = condition?.range
            }

            newConditions.push(filters)
        } else if (condition?.range) {
            newConditions.push(
                {
                    range: condition?.range
                }
            )
        }
    });

    try {
        let data = yield call(
            clientQuery,
            query,
            {
                conditions: newConditions || [],
                sort: sort,
                limit: rows,
                offset: (rows * page),
            },
            endpoints.GRAPHQL_GENERAL,
        );
        if (data?.result) {
            yield put(getDataViewResult(data.result, entity))
        }

    } catch (exc) {
        yield put(getDataViewResult({ error: exc?.error || true }, entity))
        ExceptionManager(exc, 'Core/common/redux/saga', 'getDataViewRequest');
    }
}

// Original searchData - used by DataView SearchInput (positional params, hardcoded limit)
// DO NOT MODIFY - legacy DataView pages depend on this exact signature
export const searchData = async (query, graphqlConditions, conditions, id, label, value, customCondition, extraField) => {

    try {
        let newConditions = [{
            fields: conditions || [],
            exact: false,
            terms: [value]
        }]

        if (Array.isArray(customCondition))
            newConditions = [...newConditions, ...customCondition];
        else
            if (customCondition) newConditions.push(customCondition);

        return await clientQuery(
            `query ${query} ($conditions: [${graphqlConditions}], $limit: Int, $offset: Int) {
                result: ${query} (conditions: $conditions, limit: $limit, offset: $offset) {
                    items {${id} ${label} ${extraField ? extraField : ""}}
                }
            }
            `,
            {
                conditions: newConditions,
                limit: 30,
                offset: 0
            },
            endpoints.GRAPHQL_GENERAL,
        );

    } catch (exc) {
        ExceptionManager(exc, 'Core/common/redux/saga', 'searchData');
    }
};

function* generateValidationCode({ payload }) {

    try {
        const { action, entityName, entityId } = payload;

        let query = `
            mutation generateVerificationCode ($action: String!, $entityName: String, $entityId: String) {
               result: generateVerificationCode (action: $action, entityName: $entityName, entityId: $entityId)
            }
        `;

        let data = yield call(
            clientMutation,
            query,
            {
                action: action,
                entityName: entityName,
                entityId: entityId
            },
            endpoints.GRAPHQL_GENERAL,
        );
        if (data) {
            yield put(generateValidationCodeResult(data))
        }

    } catch (exc) {
        yield put(generateValidationCodeResult({ error: exc?.error || true }))
        ExceptionManager(exc, 'Core/common/redux/saga', 'generateValidationCode', false);
    }
}

function* watchMethods() {
    yield takeEvery(COMMON_DATAVIEW_GET_DATA_REQUEST, getDataViewRequest);
    yield takeEvery(GENERATE_VALIDATION_CODE, generateValidationCode);
}

export default function* rootSaga() {
    yield all([fork(watchMethods)]);
}